<script src="course-pages/creative-course/creative-course.component.spec.ts"></script>
<section class="header-education">
	<div class="container_education">
		<div class="header-education__inner">
			<a href="/" class="header-education__btn-back">
				<img class="header-education__icon-back" src="assets/images/education/icons/icon__back-arrow.svg">
				На главную bbdo moscow
			</a>

			<a class="header-education__logo" href="/">
				<img class="logo" src="assets/images/education/icon__logo.svg">
			</a>
		</div>
	</div>
</section>

<section class="hero">
	<div class="container_education">
		<div class="hero__inner">
			<div class="hero__left">
				<h1 class="hero__title">ОБУЧЕНИЕ И СТАЖИРОВКИ В <span>BBDO</span></h1>
			</div>
			<div class="hero__right">
				<div class="hero__circle hero__circle--black">
					<h3>Гибкий формат</h3>
				</div>
				<div class="hero__circle hero__circle--white hero__circle--decor">
					<h3>Крутая <span>команда</span></h3>
				</div>
				<div class="hero__circle hero__circle--white">
					<h3>Атмосферный офис</h3>
				</div>
				<div class="hero__circle hero__circle--border">
					<img class="hero__icon-rings" src="assets/images/education/icons/icon__rings.svg" alt="">
				</div>
			</div>
		</div>

		<div class="hero__content">
			<h3 class="hero__text hero__text--bold">Получи <span>реальный опыт</span> в рекламе.</h3>
			<h3 class="hero__text">Узнавай новое, практикуйся, запускай свою карьеру</h3>
		</div>
	</div>
</section>

<section class="reviews">
	<div class="container_education">
		<div class="reviews__inner">
			<div class="reviews__left">
				<h2 class="section-title">ОТЗЫВЫ</h2>
				<h3 class="reviews__subtitle">Что думают о нас стажёры?</h3>
			</div>

			<div class="reviews__right">
				<div class="swiper-container reviews__slider">
					<div class="swiper-wrapper">
						<div class="swiper-slide reviews__slide" *ngFor="let data of reviewsData" id="{{data.id}}">
							<div class="reviews__picture">
								<img src="{{environment.url}}{{data.preview_photo}}" alt="">
							</div>
							<div class="reviews__name">{{ data.name }}</div>
						</div>
					</div>
					<div class="swiper-pagination"></div>
				</div>
				<div class="reviews__slider-button-prev">
					<img src="assets/images/education/icons/icon__arrow-slider--left.svg" alt="">
				</div>
				<div class="reviews__slider-button-next">
					<img src="assets/images/education/icons/icon__arrow-slider--right.svg" alt="">
				</div>
			</div>

		</div>
	</div>
</section>

<section class="directions" id="parentComponentAnchor">
	<div class="container_education">
		<h2 class="section-title directions__title">ВЫБЕРИ НАПРАВЛЕНИЕ</h2>

		<div class="directions__inner">
			<div *ngFor="let data of courseData">
				<app-course-card
					[data]="data"
					[course]="false">
				</app-course-card>
			</div>
		</div>
	</div>
</section>

<section class="line-text">
	<div class="line-text__inner">
		<div class="line-text__item line-text__item--bold">Не знаешь, с чего начать?</div>
		<div class="line-text__item line-text__item--stroke">Не знаешь, с чего начать?</div>
		<div class="line-text__item line-text__item--bold">Не знаешь, с чего начать?</div>
		<div class="line-text__item line-text__item--stroke">Не знаешь, с чего начать?</div>
	</div>
	<div aria-hidden="true" class="line-text__inner">
		<div class="line-text__item line-text__item--bold">Не знаешь, с чего начать?</div>
		<div class="line-text__item line-text__item--stroke">Не знаешь, с чего начать?</div>
		<div class="line-text__item line-text__item--bold">Не знаешь, с чего начать?</div>
		<div class="line-text__item line-text__item--stroke">Не знаешь, с чего начать?</div>
	</div>
</section>

<section class="testing">
	<div class="container_education">
		<div class="testing__inner">
			<h2 class="testing__title">Пройди тест и узнай свою суперсилу</h2>
			<button class="testing__button" (click)="openModal('career-test');">пройти</button>
		</div>
	</div>
</section>

<section class="line-text">
	<div class="line-text__inner">
		<div class="line-text__item line-text__item--bold">Подпишись на нас</div>
		<div class="line-text__item line-text__item--stroke">Подпишись на нас</div>
		<div class="line-text__item line-text__item--bold">Подпишись на нас</div>
		<div class="line-text__item line-text__item--stroke">Подпишись на нас</div>
	</div>
	<div aria-hidden="true" class="line-text__inner">
		<div class="line-text__item line-text__item--bold">Подпишись на нас</div>
		<div class="line-text__item line-text__item--stroke">Подпишись на нас</div>
		<div class="line-text__item line-text__item--bold">Подпишись на нас</div>
		<div class="line-text__item line-text__item--stroke">Подпишись на нас</div>
	</div>
</section>

<section class="subscription">
	<div class="container_education">
		<div class="subscription__inner">
			<div class="subscription__left">
				<img class="subscription__icon" src="assets/images/education/icons/icon__telegram.svg" alt="">
				<a href="https://t.me/bbdo_twtw" target="_blank" class="subscription__button">
					подписаться
					<img class="subscription__icon subscription__icon--mobile"
						 src="assets/images/education/icons/icon__telegram--mobile.svg" alt="">
				</a>
			</div>
			<img class="subscription__right subscription__right--desktop"
				 src="assets/images/education/photo__mobile.png" alt="">
			<img class="subscription__right subscription__right--mobile"
				 src="assets/images/education/photo__mobile--mobile.png" alt="">
		</div>
	</div>
</section>

<app-view-video ></app-view-video>
<app-career-test></app-career-test>

